<template>
  <div>
    <h2>Referrer</h2>
    <p>Listed below are statistics for this referrer</p>
    <p v-if="entity">
      <span>Go to referrer in the address book</span>
      <EntityZ :entity="entity" />
    </p>
    <p v-if="!tallies">No data</p>
    <table border="1" v-if="tallies">
      <tr>
        <th>Month</th>
        <th colspan="2">Total</th>
        <th colspan="2">Quot</th>
        <th colspan="2">Enqu</th>
        <th colspan="2">Inst</th>
        <th>Cost</th>
        <th>cpi</th>
        <th>Conv rate</th>
        <th>Year</th>
      </tr>
      <tbody
        v-for="referralYear in tallies.referralYear"
        :key="referralYear.year"
      >
        <tr>
          <td class="referrerYear" colspan="13">{{ referralYear.year }}</td>
        </tr>
        <tr
          v-for="referralMonth in referralYear.referralMonth"
          :key="`${referralMonth.year}-${referralMonth.month}`"
        >
          <td>{{ referralMonth.monthName }}</td>
          <td class="referrerNumber">{{ referralMonth.totalSp }}</td>
          <td class="referrerNumber">{{ referralMonth.total }}</td>
          <td class="referrerNumber referrerQuote">
            {{ referralMonth.quoteSp }}
          </td>
          <td class="referrerNumber referrerQuote">
            {{ referralMonth.quote }}
          </td>
          <td class="referrerNumber referrerEnquiry">
            {{ referralMonth.enquirySp }}
          </td>
          <td class="referrerNumber referrerEnquiry">
            {{ referralMonth.enquiry }}
          </td>
          <td class="referrerNumber referrerInstructed">
            {{ referralMonth.instructedSp }}
          </td>
          <td class="referrerNumber referrerInstructed">
            {{ referralMonth.instructed }}
          </td>
          <td class="referrerNumber">{{ referralMonth.cost | toCurrency }}</td>
          <td class="referrerNumber">
            {{ referralMonth.costPerInstruction | toCurrency }}
          </td>
          <td class="referrerNumber">{{ referralMonth.conversionRate }}%</td>
          <td class="referrerNumber">{{ referralMonth.yearTally }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Referrer",
  metaInfo() {
    return {
      title: "Referrer",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: { EntityZ },
  data() {
    return { tallies: null, entity: null };
  },
  methods: {
    async fetchTallies() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/${this.$route.params.id}/tallies`
      );
      // console.log(response.data);
      this.tallies = response.data;
    },
    async fetchEntity() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.entity = response.data;
    },
  },
  created() {
    this.fetchTallies();
    this.fetchEntity();
  },
};
</script>

<style scoped>
.referrerNumber {
  text-align: right;
}

.referrerQuote {
  background: #ffcccc;
}

.referrerEnquiry {
  background: #ffffcc;
}

.referrerInstructed {
  background: #ccffcc;
}

.referrerYear {
  text-align: center;
}
</style>